import React from 'react';
import { OrderlyOrderBookIcon } from '../../components/icon/CrossSwapIcons';

export function ConnnectIcon(props) {
  return (
    <svg
      {...props}
      width="101"
      height="32"
      viewBox="0 0 101 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 -0.000198364L23.6365 -0.000198921L30 6.36328L30 -0.000198364Z"
        fill="#00C6A2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99899 1.81787H18.1806V9.37106L13.6687 13.5607L9.99899 9.89104V1.81787ZM13.5986 17.3475L18.1806 13.0927V29.999H9.99899V13.7479L13.5986 17.3475ZM19.086 19.0791C19.2368 19.0869 19.3887 19.0909 19.5416 19.0909C24.3112 19.0909 28.1777 15.2244 28.1777 10.4547C28.1777 8.54742 27.5594 6.78451 26.5123 5.35552L19.086 12.2514V19.0791ZM19.086 8.52974L24.5729 3.43475C23.1561 2.41753 21.4188 1.81858 19.5416 1.81858C19.3887 1.81858 19.2368 1.82255 19.086 1.83039V8.52974ZM9.09069 1.8186H0V13.5248L6.81662 6.70814L9.09069 8.98222V1.8186ZM9.09069 12.8391L6.81662 10.565L0 17.3816V29.9997H9.09069V12.8391ZM29.9995 29.9993H19.0907V19.0905L29.9995 29.9993Z"
        fill="url(#paint0_linear_2089_639)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.364 20.4801C98.4268 27.1361 92.2814 32 85 32C77.7186 32 71.5732 27.1361 69.6357 20.4801H79.5693C80.8606 22.0435 82.8139 23.0398 85 23.0398C87.186 23.0398 89.1393 22.0435 90.4306 20.4801H100.364ZM100.68 19.2001H91.2722C91.7631 18.2399 92.04 17.1522 92.04 15.9998C92.04 14.8477 91.7632 13.7602 91.2725 12.8002H100.68C100.89 13.8341 101 14.9042 101 16C101 17.0959 100.89 18.1661 100.68 19.2001ZM78.7277 19.2001C78.2368 18.2399 77.96 17.1522 77.96 15.9998C77.96 14.8477 78.2367 13.7602 78.7274 12.8002H69.32C69.1102 13.8341 69 14.9042 69 16C69 17.0959 69.1102 18.1661 69.3201 19.2001H78.7277ZM72.1992 6.39946C71.0576 7.9192 70.1803 9.64886 69.6356 11.5202H79.5689C80.8601 9.95645 82.8137 8.95984 85 8.95984C87.1863 8.95984 89.1398 9.95645 90.4311 11.5202H100.364C99.8197 9.64886 98.9424 7.9192 97.8008 6.39946H72.1992ZM96.731 5.11946H73.269C76.191 1.97052 80.3654 0 85 0C89.6346 0 93.809 1.97052 96.731 5.11946Z"
        fill="url(#paint1_linear_2089_639)"
      />
      <circle cx="41.5" cy="17.5" r="1.5" fill="#D9D9D9" />
      <circle cx="49.5" cy="17.5" r="1.5" fill="#D9D9D9" />
      <circle cx="57.5" cy="17.5" r="1.5" fill="#D9D9D9" />
      <defs>
        <linearGradient
          id="paint0_linear_2089_639"
          x1="14.089"
          y1="1.81787"
          x2="14.089"
          y2="29.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2089_639"
          x1="85"
          y1="0"
          x2="85"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function OrderlyIcon({ isActive }: { isActive: boolean }) {
  if (isActive)
    return <OrderlyOrderBookIcon style={{ width: '18px', height: '18px' }} />;
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="5" fill="white" fillOpacity="0.2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2816 10.5396C13.6157 12.8278 11.5031 14.5 9 14.5C6.49687 14.5 4.38429 12.8278 3.7184 10.5396H7.1348C7.57866 11.0773 8.25032 11.4201 9.00203 11.4201C9.75374 11.4201 10.4254 11.0773 10.8693 10.5396H14.2816ZM14.3901 10.0996H11.1584C11.327 9.76969 11.422 9.39599 11.422 9.00008C11.422 8.60413 11.3269 8.23039 11.1583 7.90045H14.3901C14.4622 8.25573 14.5 8.62345 14.5 9C14.5 9.37657 14.4622 9.74431 14.3901 10.0996ZM6.84566 10.0996C6.6771 9.76969 6.58203 9.39599 6.58203 9.00008C6.58203 8.60413 6.67712 8.23039 6.84571 7.90045H3.60993C3.53784 8.25573 3.5 8.62345 3.5 9C3.5 9.37657 3.53785 9.74431 3.60994 10.0996H6.84566ZM4.60051 5.69879C4.20762 6.22156 3.90573 6.81662 3.71838 7.46045H7.13488C7.57874 6.92277 8.25037 6.58008 9.00203 6.58008C9.7537 6.58008 10.4253 6.92277 10.8692 7.46045H14.2816C14.0943 6.81662 13.7924 6.22156 13.3995 5.69879H4.60051ZM13.0316 5.25879H4.96842C5.97282 4.17694 7.40736 3.5 9 3.5C10.5926 3.5 12.0272 4.17694 13.0316 5.25879Z"
        fill="white"
        fillOpacity="0.5"
      />
    </svg>
  );
}
export function CheckedIcon() {
  return (
    <svg
      width="11"
      height="9"
      viewBox="0 0 11 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2666 4.00016L4.11105 6.66683L9.79994 1.3335"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function KeyIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63116 10.4996C10.2143 11.3485 10.5556 12.3765 10.5556 13.4843C10.5556 16.3991 8.19261 18.762 5.27778 18.762C2.36294 18.762 0 16.3991 0 13.4843C0 10.5694 2.36294 8.20649 5.27778 8.20649C6.54383 8.20649 7.70577 8.65228 8.61518 9.39545L15.0844 2.9262L17.041 0.96967C17.3339 0.676777 17.8087 0.676777 18.1016 0.96967C18.3945 1.26256 18.3945 1.73744 18.1016 2.03033L16.6993 3.43268L18.7148 5.27836C18.8658 5.41656 18.9537 5.61042 18.9582 5.815C18.9627 6.01958 18.8834 6.21712 18.7387 6.36182L15.572 9.52849C15.2912 9.80928 14.8402 9.82254 14.5434 9.55871L12.4415 7.6904L9.65718 10.4748C9.64865 10.4833 9.63998 10.4916 9.63116 10.4996ZM15.0114 7.96777L13.504 6.62791L15.6376 4.49437L17.1238 5.85534L15.0114 7.96777ZM9.05556 13.4843C9.05556 15.5707 7.36419 17.262 5.27778 17.262C3.19137 17.262 1.5 15.5707 1.5 13.4843C1.5 11.3979 3.19137 9.70649 5.27778 9.70649C7.36419 9.70649 9.05556 11.3979 9.05556 13.4843Z"
        fill="currentColor"
      />
    </svg>
  );
}
